export default "__VITE_PUBLIC_ASSET__d49e2556__"